<template>
  <BaseInput
    v-model="getValue"
    class="input-money"
    type="text"
    inputmode="numeric"
    :money="c_money"
    :mask="mask"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import BaseInput from '~/components/Base/Input'

export default {
  name: 'BaseInputMoney',
  components: { BaseInput },
  props: {
    value: { type: [String, Number] },
    min: { type: [String, Number], default: 0 },
    max: { type: [String, Number] },
    money: { type: Object },
    mask: { type: String, default: '' },
  },
  computed: {
    getValue: {
      get() {
        return this.value.toString()
      },
      set(v) {
        this.inputHandler(v)
        this.$emit('input', parseInt(v, 10))
      },
    },
    c_money() {
      // money: {
      //   decimal: ',',
      //   thousands: '.',
      //   prefix: 'R$ ',
      //   suffix: ' #',
      //   precision: 2,
      //   masked: false
      // }

      return this.money
        || {
          thousands: ' ',
          precision: 0,
        }
    },
  },
  methods: {
    inputHandler(v) {
      if (!isNaN(this.max)) {
        if (v > this.max) {
          setTimeout(() => {
            this.getValue = this.max
          })
        }
      }
      if (!isNaN(this.min)) {
        if (v < this.min) {
          setTimeout(() => {
            this.getValue = this.min
          })
        }
      }
    },
  },
}
</script>
